<template>
  <section>
    <!-- Header -->
    <leftMenu />
    <modal-feedback :data-modal="dataModal" :dataPage.sync="valueEmit"/>

    <div id="mainContent" class="balance-hours-content">
      <div class="row">
        <div v-if="showFeedback" class="col-xs-12 col-sm-12 col-md-12 pg-title">
          <h1 class="certa">{{$t("Feedbacks")}}</h1>
        </div>

        <div v-if="showFeedback" class="col-xs-12 col-sm-12 col-md-12 offset-top-30">
            <div class="box-qtd-feedback">
              <span v-on:click="getAllFeedback('received')" v-bind:class="{'active': typeSearch === 'received'}">{{$t("Recebidos")}}</span>
              <span v-on:click="getAllFeedback('sent')" v-bind:class="{'active': typeSearch === 'sent'}">{{$t("Enviados")}}</span>
              <span v-on:click="getAllFeedback('requested')" v-bind:class="{'active': typeSearch === 'requested'}">{{$t("Solicitações")}}</span>
            </div>

          <div class="btn-search">
            <button v-if="dataPermissions.canRequestFeedback" v-on:click="openModalFeedback(3)">{{$t("Solicitar Feedback")}}</button>
            <button v-if="dataPermissions.canSendFeedback" v-on:click="openModalFeedback(1)">{{$t("Novo Feedback")}}</button>
          </div>
        </div>

        <loading-page v-if="loading" />

        <div v-if="!loading" class="col-xs-12 col-sm-12 col-md-12 padding-null offset-top-30">
          <div class="col-xs-12 col-sm-12 col-md-12 default-box box-balance-by-date">
            <div class="col-12 content-search">
              <div class="infos">
                <h2 class="certa">{{$t("Lista de Feedbacks")}}</h2>
              </div>

              <div class="select-date">
                <div>
                  <p class="nunito">{{$t("Mostrar período de")}}</p>
                  <datepicker v-model="initDate" :language="ptBR" :format="customFormatter"/>
                  <svg width="24" height="24" viewBox="0 0 24 24">
                    <path class="a" d="M20,3H19V1H17V3H7V1H5V3H4A2.006,2.006,0,0,0,2,5V21a2.006,2.006,0,0,0,2,2H20a2.006,2.006,0,0,0,2-2V5A2.006,2.006,0,0,0,20,3Zm0,18H4V8H20Z"/>
                  </svg>
                </div>
                <div>
                  <p class="nunito at">{{$t("até")}}</p>
                  <datepicker v-model="finalDate" :language="ptBR" :format="customFormatter"/>
                  <svg width="24" height="24" viewBox="0 0 24 24">
                    <path class="a" d="M20,3H19V1H17V3H7V1H5V3H4A2.006,2.006,0,0,0,2,5V21a2.006,2.006,0,0,0,2,2H20a2.006,2.006,0,0,0,2-2V5A2.006,2.006,0,0,0,20,3Zm0,18H4V8H20Z"/>
                  </svg>
                </div>
              </div>
            </div>

            <div v-if="dataList.length" class="table-responsive table-clean">
              <table class="table">
                <thead>
                <tr>
                  <th v-if="typeSearch === 'received'" class="certa no-wrap">{{$t("Feedback recebido de")}}</th>
                  <th v-if="typeSearch === 'sent'" class="certa no-wrap">{{$t("Feedback enviado para")}}</th>
                  <th v-if="typeSearch === 'requested'" class="certa no-wrap">{{$t("Solicitante/Solicitado para")}}</th>
                  <th v-if="typeSearch === 'received'" class="certa no-wrap">{{$t("Recebido em")}}</th>
                  <th v-if="typeSearch === 'sent'" class="certa no-wrap">{{$t("Enviado em")}}</th>
                  <th v-if="typeSearch === 'requested'" class="certa no-wrap">{{$t("Solicitado em")}}</th>
                  <th v-if="typeSearch === 'requested'" class="certa no-wrap">{{$t("Status")}}</th>
                  <th class="certa no-wrap">{{$t("Ações")}}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(d, key) in dataList">
                  <td v-if="typeSearch === 'received' || typeSearch === 'requested'" class="content-photo-and-infos">
                    <div class="photo">
                      <p v-if="!d.fromUserPhotoUri">{{d.fromUserName | formatName}}</p>
                      <img v-bind:src="d.fromUserPhotoUri" v-if="d.fromUserPhotoUri" alt="photo" />
                    </div>
                    <a class="no-link" v-bind:class="{'anonymous': !d.fromUserOffice}">
                      <span v-bind:title="d.fromUserName">{{d.fromUserName}}</span>
                    </a>
                    <p v-bind:title="d.fromUserOffice" class="office">{{d.fromUserOffice}}</p>
                  </td>
                  <td v-if="typeSearch === 'sent'" class="content-photo-and-infos">
                    <div class="photo">
                      <p v-if="!d.toUserPhotoUri">{{d.toUserName | formatName}}</p>
                      <img v-bind:src="d.toUserPhotoUri" v-if="d.toUserPhotoUri" alt="photo" />
                    </div>
                    <a class="no-link">
                      <span v-bind:title="d.toUserName">{{d.toUserName}}</span>
                    </a>
                    <p v-bind:title="d.toUserOffice" class="office">{{d.toUserOffice}}</p>
                  </td>
                  <td>
                    <p class="capitalize">{{d.sentIn | formatDateHoursSeconds}}</p>
                  </td>
                  <td v-if="typeSearch === 'requested'">
                    <p class="status-requested">Solicitação recebida</p>
                  </td>
                  <td v-if="typeSearch !== 'requested'">
                    <a v-on:click="openModalFeedback(2, d)" target="_blank" class="default-btn-transparent">{{$t("Ver feedback")}}</a>
                  </td>
                  <td v-if="typeSearch === 'requested'">
                    <a v-on:click="openModalFeedback(4, d)" target="_blank" class="default-btn-transparent">{{$t("Responder solicitação")}}</a>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>

            <div v-if="!dataList.length && !failRequest" class="col-xs-12 col-sm-12 col-md-12 box-empty offset-top-40">
              <img src="../../../../assets/img/empty/comunicados.png" alt="Comunicado" class="img-fluid" />
              <p v-if="isSearch" class="nunito offset-top-30">{{$t("Nenhum feedback disponível na data")}} {{initDate | formatDate}} {{$t("selecionada.")}}</p>
              <p v-if="!isSearch && typeSearch === 'received'" class="nunito offset-top-30">{{$t("Você ainda não recebeu nenhum feedback até o momento.")}}</p>
              <p v-if="!isSearch && typeSearch === 'sent'" class="nunito offset-top-30">{{$t("Você ainda não enviou nenhum feedback até o momento.")}}</p>
              <p v-if="!isSearch && typeSearch === 'requested'" class="nunito offset-top-30">{{$t("Você não recebeu nenhuma solicitação de feedback até o momento.")}}</p>
            </div>
          </div>

          <div v-if="!dataList.length && failRequest" class="col-xs-12 col-sm-12 col-md-12 offset-top-40 box-empty">
            <img src="../../../../assets/img/empty/internet.png" alt="internet" class="img-fluid img-responsive" />
            <p class="nunito">{{$t("Tivemos um problema com a conexão, tente novamente atualizando a página.")}}</p>
          </div>


        </div>
      </div>
    </div>

    <!-- Footer -->
    <vue-footer/>
  </section>
</template>

<script>
  import leftMenu from '../../components/leftMenu.vue';
  import loadingPage from '../../components/loadingPage.vue';
  import modalFeedback from '../../modals/modalFeedback.vue';
  import vueFooter from "../../components/footer";

  import {FEEDBACK_CHECK_PERMISSION, GET_FEEDBACK} from "../../../../urlConfig";
  import { REQUEST_SERVICE } from "../../../../requestConfig";
  import { UTIL_SERVICE } from "../../../../utils";
  import moment from "moment";
  import ptBR from "vuejs-datepicker/dist/locale/translations/pt-BR";
  import datepicker from "vuejs-datepicker";

  export default {
    name: 'feedback',
    components: {
      leftMenu,
      loadingPage,
      modalFeedback,
      datepicker,
      vueFooter
    },
    data() {
      return {
        initDate: new Date(moment().subtract(3, 'month')),
        finalDate: new Date(moment().subtract(0, 'days')),
        loading: false,
        failRequest: false,
        showFeedback: false,
        dataList: [],
        dataPermissions: {},
        dataModal: '',
        typeSearch: '',
        valueEmit: '',
        ptBR: ptBR,
        isSearch: false
      }
    },
    methods: {
      customFormatter(date) {
        return moment(date).format('DD/MM/YYYY');
      },
      getAllFeedback(type) {
        this.dataList = [];
        this.typeSearch = type;
        this.loading = true;
        this.failRequest = false;

        let url = `${GET_FEEDBACK}/${type}`;
        url += "?p=1";
        url += "&r=30";
        url += "&init=" + moment(this.initDate).format("YYYY-MM-DD");
        url += "&end=" + moment(this.finalDate).format("YYYY-MM-DD");

        REQUEST_SERVICE.get(url).then((response) => {
          UTIL_SERVICE.console("RESULT GET_FEEDBACK:", response.data);

          this.showFeedback = response.data.access;

          if(!response.data.access) {
            return window.location.pathname = '/';
          }

          const homeCtrl = UTIL_SERVICE.getStorage('homeCtrl');
          homeCtrl.feedbacks = response.data.items;
          UTIL_SERVICE.saveStorage('homeCtrl', homeCtrl)

          this.dataList = response.data.items;

          this.loading = false;
        }).catch(reason => {
          this.loading = false;
          this.failRequest = true;

        })
      },
      searchFilter() {
        if (!this.loading) {
          this.isSearch = true;
          this.getAllFeedback(this.typeSearch);
        }
      },
      getPermissions() {
        this.loading = true;
        this.failRequest = false;

        REQUEST_SERVICE.get(FEEDBACK_CHECK_PERMISSION).then((response) => {
          UTIL_SERVICE.console("FEEDBACK_CHECK_PERMISSION:", response.data);

          this.dataPermissions = response.data;

          this.loading = false;
        }).catch(reason => {
          this.loading = false;
          this.failRequest = true;

        })
      },
      openModalFeedback(type, data) {
        this.dataModal = {};
        this.dataModal.modalType = type;
        this.dataModal.data = data || {};
        this.dataModal.typeSearch = this.typeSearch;
        this.dataModal.random = Math.floor(Math.random() * 100);

        $("#modalFeedback").modal({backdrop: 'static',keyboard: false});
      }
    },
    watch: {
      initDate: function(val) {
        if (this.finalDate && this.initDate){
          this.getAllFeedback(this.typeSearch);
        }
      },
      finalDate: function(val) {
        if (this.finalDate && this.initDate){
          this.getAllFeedback(this.typeSearch);
        }
      },
      valueEmit: function (response) {
        if (response.reloadPg) {
          this.getAllFeedback(response.type);
        }
        this.dataModal = '';
      }
    },
    beforeMount() {
      this.getAllFeedback('received');
      this.getPermissions();
    }
  }
</script>

<!-- Style from page -->
<style lang="scss">
.select-date {
  margin: 20px 0 20px;

  div {
    display: inline-block;
    position: relative;

    p {
      color: var(--defaultText);
      display: inline-block;
    }

    .at {
      margin-left: 17px;

      @media only screen and (max-device-width: 420px) {
        margin-left: 0;
      }
    }

    svg {
      display: inline-block;
      position: absolute;
      right: 83px;
      width: 17px;
      top: 2px;
      fill: var(--titleBox);

      @media only screen and (max-device-width: 420px) {
        left: 8px;
        right: 0;
        top: 34px;
      }
    }

    img {
      display: inline-block;
      position: absolute;
      right: 83px;
      width: 17px;
      top: 7px;

      @media only screen and (max-device-width: 420px) {
        left: 8px;
        right: 0;
        top: 36px;
      }
    }

    .vdp-datepicker {
      display: inline-block;
      width: 120px;

      input {
        width: 120px;
        background: #F2F5F9;
        color: #3A424E;
        border: none;
        height: 31px;
        border-radius: 4px;
        margin-right: 10px;
        margin-left: 10px;
        padding-left: 34px;
        cursor: pointer;

        @media only screen and (max-device-width: 420px) {
          margin-left: 0;
        }
      }

      .vdp-datepicker__calendar {
        position: absolute;
        left: 10px;
        top: 32px;
      }

      @media only screen and (max-device-width: 420px) {
        display: block;
        margin-right: 10px;
        margin-bottom: 10px;
      }
    }
  }

  .search-btn {
    button {
      background: var(--blueDark);
      border-radius: 4px;
      color: #ffffff;
      border: none;
      display: block;
      height: 31px;
      width: 100%;
      font-size: 15px;
      padding: 0 50px;
      margin: 30px auto 0 24px;

      @media only screen and (max-device-width: 780px) {
        margin: 0;
      }
    }
  }
}

.anonymous {
  position: relative;
  top: 10px;
}

.content-search {
  margin-top: 20px;
  margin-bottom: 30px;
  position: relative;

  h2 {
    margin-bottom: 20px;
  }

  label {
    position: absolute;
    top: -25px;
    font-family: 'Montserrat', sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: var(--defaultText);
  }

  ion-icon {
    position: absolute;
    top: 10px;
    left: 25px;
  }

  input {
    height: 36px;
    border-radius: 4px;
    padding: 0 6px 0 34px;
  }


  button {
    margin-left: 40px;
    cursor: pointer;
    background: var(--linkColor);
    font-style: normal;
    font-weight: 500;
    color: #ffffff;
    font-size: 14px;
    width: 100%;
    height: 36px;
    border-radius: 4px;
    border: none;
    text-align: center;
  }
}

.box-alert {
  cursor: pointer;
  position: relative;

  .block-urgent {
    position: absolute;
    background: var(--redColor);
    color: #ffffff;
    font-size: 12px;
    padding: 2px 8px;
    line-height: 16px;
    top: -6px;
    left: 0;
    border-radius: 5px 5px 0 0;
  }

  &:hover {
    text-decoration: none !important;
  }
}

.box-qtd-feedback {
  background: rgba(127, 136, 151, 0.25);
  border-radius: 30px;
  display: inline-block;
  padding: 0;

  span {
    color: var(--defaultText);
    display: inline-block;
    border-radius: 30px;
    padding: 7px 13px;
    cursor: pointer;
    font-family: 'Montserrat', sans-serif;

    &:hover {
      background: var(--linkColor);
      color: #ffffff;
    }
  }

  .active {
    background: var(--linkColor);
    color: #ffffff;
  }
}

.btn-search {
  float: right;

  button {
    font-family: "Montserrat", sans-serif;
    min-width: 137px;
    height: 36px;
    border-radius: 4px;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;

    &:first-of-type {
      background: transparent;
      border: 1px solid var(--linkColor);
      color: var(--linkColor);
    }

    &:last-of-type {
      background: var(--linkColor);
      border: 1px solid var(--linkColor);
      color: #ffffff;
      margin-left: 14px;
    }
  }
}

.content-photo-and-infos {
  white-space: nowrap;
  height: 70px;
  position: relative;
  top: 2px;

  .photo {
    width: 48px;
    height: 48px;
    background: var(--bodyColor);
    border-radius: 100%;
    position: absolute;
    margin-top: 1px;

    img {
      width: 48px;
      height: 48px;
      position: absolute;
      border-radius: 100%;
      top: 0;
      left: 0;
      object-fit: cover;
    }

    p {
      text-align: center;
      line-height: 48px;
      font-weight: bold;
      text-transform: uppercase;
      font-size: 18px;
      font-family: "Montserrat", sans-serif;
    }
  }

  .no-link {
    margin-left: 58px;
    font-family: "Montserrat", sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    color: var(--titleBox);
    display: inline-block;
    cursor: default;
    margin-top: 4px;
    margin-bottom: 1px;
    min-height: 21px;

    &:hover {
      text-decoration: none;
      color: var(--titleBox) !important;
    }

    span {
      margin-right: 4px;
    }
  }

  .office {
    padding-left: 58px;
    font-size: 12px;
    margin: 0;
  }
}

.default-btn-transparent {
  cursor: pointer;
  margin-top: 0;
  display: inline-block;
  border: 1px solid var(--linkColor);
  color: var(--linkColor);
  background-color: transparent;
  border-radius: 25px;
  padding: 5px 10px;
  font-size: 12px;
  white-space: nowrap;

  &:hover {
    text-decoration: none;
    color: #ffffff;
    background-color: var(--linkColor);
  }
}

.box-empty {
  p {
    margin-top: 30px !important;
  }
}

.status-requested {
  font-family: 'Montserrat', sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  text-align: center;background: #FDD944;
  border-radius: 5px;
  max-width: 170px;
  color: #3A424E;
  padding: 4px 0;
}
</style>



// WEBPACK FOOTER //
// src/vue/views/restricted/feedback/feedback.vue